export const NOTES_DELETE_REQUEST = "NOTES_DELETE_REQUEST";
export const NOTES_DELETE_RESULT = "NOTES_DELETE_RESULT";
export const NOTES_DELETE_OPEN_MODAL = "NOTES_DELETE_OPEN_MODAL";